import React, { ReactNode } from 'react';

export default function InfoBox(props: { title: string; children: ReactNode; className?: string }) {
    return (
        <div className={`box-shadow py-7 px-2 ${props.className}`}>
            <h2 className={'mb-5 text-center font-medium '}>{props.title}</h2>
            <p className={'text-center'}>{props.children}</p>
        </div>
    );
}
